import { HEADER_DISPLAY_TYPE_TOGGLE } from './types';

export const header_display_type_toggle = (header_display_type) => ({
  type: HEADER_DISPLAY_TYPE_TOGGLE,
  payload: header_display_type,
});